import { useEffect, useState } from "react";
import api from "@/lib/api";
import Reveal from "@/components/Reveal";
import { useUiTexts } from "@/lib/uiTexts";

export default function PartnerStrip() {
  const [partners, setPartners] = useState(null);
  const texts = useUiTexts();

  useEffect(() => {
    api.get("/partners").then((r) => setPartners(r.data)).catch(() => setPartners([]));
  }, []);

  if (!partners || partners.length === 0) return null;

  return (
    <section className="border-y border-orange-500/15 bg-[#0B132B]/40" data-testid="partner-strip">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-8">
        <Reveal>
          <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-slate-500">{texts.partners_label}</p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
            {partners.map((p) => {
              const content = p.logo_url ? (
                <img src={p.logo_url} alt={`Logo ${p.name}`} loading="lazy"
                  className="h-10 max-w-[140px] object-contain opacity-50 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0 sm:h-12" />
              ) : (
                <span className="font-heading text-lg font-black uppercase tracking-tight text-slate-500 transition-colors hover:text-orange-400">
                  {p.name}
                </span>
              );
              return p.url ? (
                <a key={p.id} href={p.url} target="_blank" rel="noreferrer" title={p.name}
                  data-testid={`partner-strip-${p.id}`}>{content}</a>
              ) : (
                <div key={p.id} data-testid={`partner-strip-${p.id}`}>{content}</div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
